import {
  fetchCalendarServices,
  fetchMapServices,
  fetchAllServices,
  fetchCalendarExport,
  fetchMapExport,
  requestBulkUpdateDateTime
} from './services';

import {
  setIsLoading,
  setIsBulkUpdateLoading,
  setCalendarList,
  setMapList
} from './actions';

export const loadCalendarServices = (userId, establishmentId, extraProps, qp) => dispatch => {
  dispatch(setIsLoading(true));

  const { initialDate, finalDate } = extraProps;

  return fetchCalendarServices(userId, establishmentId, initialDate, finalDate, qp)
    .then(({ data }) => {
      dispatch(setCalendarList(data?.data || []));
      return Promise.resolve(data?.data);
    })
    .catch(() => {
      return Promise.reject([]);
    })
    .finally(() => dispatch(setIsLoading(false)));
}

export const loadMapServices = (userId, establishmentId, startDate, endDate, qp) => dispatch => {
  dispatch(setIsLoading(true));

  return fetchMapServices(userId, establishmentId, startDate, endDate, qp)
    .then(({ data }) => dispatch(setMapList(data?.data || [])))
    .finally(() => dispatch(setIsLoading(false)));
}

export const loadAllServices = (userId, establishmentId) => dispatch => {
  dispatch(setIsLoading(true));

  return fetchAllServices(userId, establishmentId)
    .then(({ data }) => console.log(data))
    .finally(() => dispatch(setIsLoading(false)));
}

export const loadCalendarExport = (userId, establishmentId) => dispatch => {
  dispatch(setIsLoading(true));

  return fetchCalendarExport(userId, establishmentId)
    .then(({ data }) => console.log(data))
    .finally(() => dispatch(setIsLoading(false)));
}

export const loadMapExport = (userId, establishmentId) => dispatch => {
  dispatch(setIsLoading(true));

  return fetchMapExport(userId, establishmentId)
    .then(({ data }) => console.log(data))
    .finally(() => dispatch(setIsLoading(false)));
}

export const bulkUpdateDateTime = (userId, establishmentId, eventsList) => dispatch => {
  dispatch(setIsBulkUpdateLoading(true));

  return requestBulkUpdateDateTime(userId, establishmentId, { events: eventsList })
    .then(() => {
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(setIsBulkUpdateLoading(false)));
}